import img1 from '../images/marble1.jpg';
import img2 from '../images/marble2.jpg';
import img3 from '../images/marble3.jpg';
import img4 from '../images/blck.jpeg';
import img5 from '../images/marble5.jpg';
import img6 from '../images/marble6.jpg'; 
import sls from '../images/SLShead.jpg';
import sls1 from '../images/sls1.jpg';
import sls2 from '../images/sls2.jpg';
import sls3 from '../images/sls3.jpg';
import sls4 from '../images/sls4.jpg';
import sls5 from '../images/sls5.jpg'; 
import sls6 from '../images/sls6.jpg';
import sls7 from '../images/sls7.jpg';
import sls8 from '../images/sls8.jpg';
import stone from '../images/stone.jpg';

import wall1 from '../images/wall (1).jpg';
import wall2 from '../images/wall (2).jpg';
import wall3 from '../images/wall (3).jpg';
import wall4 from '../images/wall (4).jpg';
import wall5 from '../images/wall (5).jpg';
import wall6 from '../images/wall (6).jpg';
import wall7 from '../images/wall (7).jpg';
import wall8 from '../images/wall (8).jpg';

import counter from '../images/counter1.jpg'
import counter1 from '../images/counter12.webp'
import counter3 from "../images/COUNTER5.webp"
import statuario from "../images/statuario.webp"
import vanity from "../images/vanity.webp"
import vanity1 from "../images/vanity1.webp"

import zulai from '../images/zulai.jpg';
import zulai1 from '../images/zulai1.jpg'; 
import zulai2 from '../images/zulai(3).jpeg'; 
import zulai3 from '../images/zulai(4).jpeg'; 
import zulai4 from '../images/zulai(5).jpeg'; 
import zulai5 from '../images/zulai(6).jpeg'; 
import zulai6 from '../images/zulai(7).jpg'; 
import zulai8 from '../images/zulai(3).jpg'; 
import zulai9 from '../images/zulai(4).jpg'; 
import zulai10 from '../images/zulai(5).jpg'; 
import zulai11 from '../images/zulai(6).jpg'; 
import zulai7 from '../images/zulai(8).jpg'; 


import armani from '../images/armani.jpg'

import burberry from '../images/burberry.jpg'
import burberry1 from '../images/burberry(1).jpg'
import burberry2 from '../images/burberry(2).jpg'
import burberry3 from '../images/burberry(3).jpg'
import burberry4 from '../images/burberry(4).jpeg'
import burberry5 from '../images/burberry(5).jpeg'
import burberry6 from '../images/burberry(6).jpeg'
import burberry7 from '../images/burberry(7).jpeg'
import burberry8 from '../images/burberry(8).jpeg'

import gap from '../images/gap.jpg'

import coach from '../images/coach.jpg'

import patchi from '../images/patchi.jpg'

import villa from '../images/villa.jpg'
import plmd921 from '../images/plmd92 (1).jpg'
import plmd922 from '../images/plmd92 (2).jpg'
import plmd923 from '../images/plmd92 (3).jpg'
import plmd924 from '../images/plmd92 (4).jpg'
import plmd925 from '../images/plmd92 (5).jpg'
import plmd926 from '../images/plmd92 (6).jpg'

import plm from '../images/plm.jpg'

import plmcvr from '../images/plmcvr.jpg'

import PLM1 from '../images/PLM1.jpg'
import plm2 from '../images/plmtwr (1).jpg'
import plm3 from  '../images/plmtwr (2).jpg'
import plm4 from  '../images/plmtwr (3).jpg' 
import plm5 from '../images/plmtwr (4).jpg' 
import plm6 from '../images/plmtwr (5).jpg'

import plm9 from  "../images/plmtwr (11).jpg"
import plm10 from  "../images/plmtwr (12).jpg"
import plm11 from  "../images/plmtwr (13).jpg"
import plm12 from  "../images/plmtwr (14).jpg"
import plm13 from  "../images/plmtwr (15).jpg"

import aha from "../images/aha.jpg"
import adh1 from '../images/Adh (1).jpg'
import adh2 from '../images/Adh (2).jpg'
import adh3 from '../images/Adh (3).jpg'
import adh4 from '../images/Adh (4).jpg'
import adh5 from '../images/Adh (5).jpg'

import sorocvr from '../images/sorocvr.jpg'
import sora from '../images/sora.jpg' 
import sora1 from '../images/sora (1).jpg' 
import sora2 from '../images/sora (2).jpg' 
import sora3 from '../images/sora (3).jpg' 
import sora4 from '../images/sora (4).jpg' 

import air from "../images/sharjcover.jpg"
import air1 from "../images/sharj (1).jpg"
import air3 from "../images/sharj (3).jpg"
import air4 from "../images/sharj (4).jpg"
import air5 from "../images/sharj (5).jpg"
import air6 from "../images/sharj (6).jpg"
import air7 from "../images/sharj (7).jpg"
import air8 from "../images/sharj (8).jpg"

import dxb from "../images/dxb.jpg"

import wb from '../images/wb.jpg'

import ahd from '../images/ahd.png'

import phd from '../images/phd.jpg'

import barari from '../images/barari.avif'
import barari1 from '../images/barari (1).jpg'
import barari2 from '../images/barari (2).jpg'
import barari3 from '../images/barari (3).jpg'
import barari4 from '../images/barari (4).jpg'
import barari5 from '../images/barari (5).jpg'
import barari7 from '../images/barari (6).jpg'
import barari8 from '../images/barari (7).jpg'
import barari9 from '../images/barari (8).jpg'
import barari6 from '../images/barari (9).jpg'

import manish from "../images/manish (1).jpg"
import manish1 from "../images/manish (2).jpg"
import manish2 from "../images/manish (3).jpg"
import manish3 from "../images/manish (4).jpg"

import toto from '../images/toto (5).jpg'
import toto1 from '../images/toto (1).jpg'
import toto2 from '../images/toto (2).jpg'
import toto3 from '../images/toto (3).jpg'
import toto4 from '../images/toto (4).jpg'
import toto5 from '../images/toto (6).jpg'

import beachwalk from '../images/BEACHWALK (2).png'
import beachwalk1 from '../images/BEACHWALK (1).jpg'
import beachwalk2 from '../images/BEACHWALK (7).jpg'
import beachwalk3 from '../images/BEACHWALK (4).jpg'
import beachwalk4 from '../images/BEACHWALK (6).jpg'
import beachwalk5 from '../images/BEACHWALK (8).jpg'
import beachwalk6 from '../images/BEACHWALK (9).jpg'
import beachwalk7 from '../images/BEACHWALK (10).jpg'
import beachwalk8 from '../images/BEACHWALK (3).jpg'
import beachwalk9 from '../images/BEACHWALK (11).jpg'


export const productdata = [
  {
    id: 1,
    image: img1,
    name: "Carrara Marble",
    type: "marble",
    origin: "Italy",
    about: "Carrara marble originates from the Carrara region in Italy. Known for its white to blue-grey appearance, it is one of the most popular marbles worldwide and is widely used in sculpture and building decor."
  },
  {
    id: 2,
    image: img2,
    name: "Alabaster Marble",
    type: "stone",
    origin: "Egypt/Italy",
    about: "Alabaster is not actually marble but a soft, translucent stone, often confused with marble. It has been used for centuries in sculpture and decor, with most historical artifacts coming from Egypt and Italy."
  },
  {
    id: 3,
    image: img3,
    name: "Pavonazzo Marble",
    type: "marble",
    origin: "Italy",
    about: "Pavonazzo Marble is a type of Italian marble that stands out for its bold veins of black and gold. It was highly prized during Roman times and is still used today for its striking appearance."
  },
  {
    id: 4,
    image: img4,
    name: "Black Marquina Marble",
    type: "marble",
    origin: "Spain",
    about: "Black Marquina marble is a high-quality black marble with white veins, quarried from Spain. It is popular in luxury interior design and for use in fireplaces, flooring, and countertops."
  },
  {
    id: 5,
    image: img5,
    name: "Calacatta Marble",
    type: "marble",
    origin: "Italy",
    about: "Calacatta Marble is renowned for its thick, bold veining in shades of grey or gold. It is one of the most luxurious types of marble, often used for statement features in kitchens and bathrooms."
  },
  {
    id: 6,
    image: img6,
    name: "Emperador Marble",
    type: "marble",
    origin: "Spain",
    about: "Emperador Marble is known for its rich brown tones and dramatic veining. Quarried in Spain, it is a popular choice for flooring, wall cladding, and countertops due to its elegant appearance."
  }
];

export const serviceData=[
  { id: 1, image: [sls1,stone,sls3,sls4,sls5,sls6,sls7,sls8], name: "The Supply and Installation of Natural Stone and Tiles ",type:"marble",origin:"Italy",about:"The Supply and Installation of Natural Stone and Tiles service provides high-quality materials and expert craftsmanship to elevate the beauty and functionality of any space. From luxurious marble and durable granite to stylish ceramic and porcelain tiles, this service caters to residential, commercial, and hospitality projects. It involves sourcing premium stones and tiles from trusted suppliers and ensuring flawless installation with attention to detail. Whether it's flooring, wall cladding, or countertops, the service transforms spaces into elegant and long-lasting environments. With a focus on precision, customization, and sustainability, clients receive tailored solutions that blend aesthetic appeal with practical durability.",  },
    { id: 2, image: [wall1,wall2,wall3,wall4,wall5,wall6,wall7,wall8], name: "Wall Cladding",type:"marble",origin:"china", about:"Wall cladding with marble is a sophisticated design solution that enhances the elegance and luxury of any space. Known for its timeless beauty, marble wall cladding adds a striking visual appeal, creating a sense of grandeur and refinement. Whether used in residential settings like living rooms and bathrooms, or in commercial spaces such as hotels, office lobbies, and galleries, marble offers a seamless blend of aesthetic charm and durability. Its natural variations in color and veining provide a unique look to each installation, ensuring that no two walls are exactly alike. Beyond its beauty, marble is also resistant to heat and moisture, making it a practical choice for both indoor and outdoor applications. Wall cladding with marble not only transforms the ambiance of a space but also adds long-lasting value and a touch of luxury to any environment."},
    { id: 3, image: [counter,statuario,vanity1,vanity,counter1,counter,counter3,counter1], name: "Counter and Vanity Tops" ,type:"marble",origin:"china",about:"Marble services for countertops and vanity tops offer premium solutions for enhancing the beauty and functionality of kitchens, bathrooms, and other areas where elegance is desired. "},
    { id: 4, image: img4, name: "Black Marquina" ,type:"marble",origin:"china",about:"Marble is composed largely of calcite or calcium carbonate (CaCO3) and Pavonazzo is no different in this sense. It is made up of this mineral and this is what gives it the characteristics that earn it the title of marble."},
    { id: 5, image: img5, name: "Calacatta Marble" ,type:"marble",origin:"china" ,about:"Marble is composed largely of calcite or calcium carbonate (CaCO3) and Pavonazzo is no different in this sense. It is made up of this mineral and this is what gives it the characteristics that earn it the title of marble."},
    { id: 6, image: img6, name: "Emperador Marble" ,type:"marble",origin:"china",about:"Marble is composed largely of calcite or calcium carbonate (CaCO3) and Pavonazzo is no different in this sense. It is made up of this mineral and this is what gives it the characteristics that earn it the title of marble."},
]
export const projectData= [
  // Residential Projects
  {
    id: 1,
    name: "Zulaikha Hospital",
    location: "Dubai, UAE",
    client: "Zulaikha Hospital",
    completionDate: "January 2024",
    category: "Hospitality",
    
    description: "Luxury apartments in the heart of Dubai with state-of-the-art facilities and amenities.",
    image: zulai, // This can be a single main image if you need
    im: [zulai1,zulai2,zulai3,zulai4,zulai5,zulai6,zulai7,zulai8,zulai9,zulai10,zulai11] // Store multiple images in an array
  },
  {
    id: 2,
    name: "S L S DUBAI,HOTEL & RESIDENTIAL",
    location: "DUBAI, UAE",
    client: "S L S DUBAI,HOTEL & RESIDENTIAL",
    completionDate: "March 2024",
    category: "Hotel & Residential",
    
    description: "Luxury apartments in the heart of Dubai with state-of-the-art facilities and amenities.",
    image:sls,
    im: [sls1, sls2, sls3, sls4, sls5,sls6, sls7,sls8] // Store multiple images in an array
  },
  {
    id: 3,
    name: "GIORGIA ARMANI",
    location: "Dubai, UAE",
    client: "GIORGIA ARMANI",
    completionDate: "May 2024",
    category: "Commercial",
   
    description: "We completed elegant marble installations for a boutique, enhancing its aesthetic with premium marble flooring and custom marble accents that add a luxurious touch to the space.",
    image: armani,
    im: [img1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },

  // Commercial Projects
  {
    id: 4,
    name: "Burberry",
    location: "Dubai, UAE",
    client: "Burberry",
    completionDate: "April 2024",
    category: "Commercial",
   
    description: "Experience timeless fashion and unique styles at our exclusive clothing boutique.",
    image: burberry,
    im: [burberry1,burberry8,burberry3,burberry4,burberry5,burberry6,burberry7,burberry2] // Store multiple images in an array
  },
  {
    id: 5,
    name: "Gap",
    location: "Dubai, UAE",
    client: "Gap",
    completionDate: "August 2024",
    category: "Commercial",
    
    description: "Your destination for chic, unique, and timeless fashion.",
    image:gap,
    im: [img1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },
  {
    id: 6,
    name: "Coach",
    location: "Dubai, UAE",
    client: "Coach",
    completionDate: "June 2023",
    category: "Commercial",
    
    description: "Your destination for stylish, unique, and timeless fashion.",
    image: coach,
    im: [img1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },

  // Hospitality Projects
  {
    id: 7,
    name: "Patchi",
    location: "Dubai, UAE",
    client: "Patchi",
    completionDate: "December 2022",
    category: "Commertial",
    
    description: "Discover elegant and trendy fashion at our boutique, where style meets sophistication.",
    image: patchi
        ,
    im: [img1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },
  {
    id: 8,
    name: "st.Regis Hotel ,Palm Tower",
    location: "Dubai, UAE",
    client: "Palm Tower",
    completionDate: "September 2024",
    category: "Hotel & Residential",
    
    description: "Delivered premium flooring and wall cladding solutions, enhancing the hotel's elegance and luxurious ambiance.",
    image: plm,
    im: [PLM1, plm2, plm3, plm4, plm5, plm6] // Store multiple images in an array
  },
  {
    id: 9,
    name: "Warner Bros",
    location: "Abu Dhabi, UAE",
    client: "Warner Bros",
    completionDate: "October 2024",
    category: "Hotel & Residential",
    
    description: "Delivered premium flooring and wall cladding solutions, enhancing the hotel's elegance and luxurious ambiance.",
    image: wb,
    im: [img1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },{
    id: 10,
    name: "American Hospital",
    location: "Dubai, UAE",
    client: "American Hospital",
    completionDate: "January 2024",
    category: "Hospitality",
    
    description: "Luxury apartments in the heart of Dubai with state-of-the-art facilities and amenities.",
    image: ahd, // This can be a single main image if you need
    im: [zulai1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },
  {
    id: 11,
    name: "Prime Hospital",
    location: "Dubai, UAE",
    client: "Prime Hospital",
    completionDate: "January 2024",
    category: "Hospitality",
    
    description: "Luxury apartments in the heart of Dubai with state-of-the-art facilities and amenities.",
    image: phd, // This can be a single main image if you need
    im: [zulai1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },
  {
    id: 12,
    name: "Al Barari Development",
    location: "Dubai, UAE",
    client: "Al barari Development",
    completionDate: "January 2024",
    category: "Hotel & Residential",
    
    description: "Delivered premium flooring and wall cladding solutions, enhancing the hotel's elegance and luxurious ambiance.",
    image: barari, // This can be a single main image if you need
    im: [barari1, barari2, barari3, barari4,barari5,barari6,barari7,barari8,barari9] // Store multiple images in an array
  },
  {
    id: 13,
    name: "Dubai Airport",
    location: "Dubai, UAE",
    client: "Government ",
    completionDate: "January 2024",
    category: "Government Projects",
    
    description: "Exclusive villas designed for modern living, offering privacy and beautiful landscapes.",
    image: dxb, // This can be a single main image if you need
    im: [zulai1, img2, img3, img4, img5, img6] // Store multiple images in an array
  },
  {
    id: 14,
    name: "Sora Restaurant ,Blue Waters Island",
    location: "Dubai, UAE",
    client: "Sora ",
    completionDate: "January 2024",
    category: "Commercial",
    
    description: "Delivered premium flooring and wall cladding solutions, enhancing the restaurant's elegance and luxurious ambiance.",
    image: sorocvr, // This can be a single main image if you need
    im: [sora, sora1, sora2, sora3, sora4] // Store multiple images in an array
  },
  {
    id: 15,
    name: "Abu dhabi Hospitality Academy",
    location: "Abu Dhabi, UAE",
    client: "Government",
    completionDate: "January 2024",
    category: "Government Projects",
    
    description: "Exclusive villas designed for modern living, offering privacy and beautiful landscapes.",
    image: aha, // This can be a single main image if you need
    im: [adh1, adh2, adh3, adh4, adh5] // Store multiple images in an array
  },
  
  {
    id: 16,
    name: "Sharjah Airport",
    location: "Dubai, UAE",
    client: "UAE Government",
    completionDate: "January 2024",
    category: "Government Projects",
    
    description: "Exclusive villas designed for modern living, offering privacy and beautiful landscapes.",
    image: air, // This can be a single main image if you need
    im: [air, air1, air3, air4, air5, air6,air7,air8] // Store multiple images in an array
  },{
    id: 17,
    name: "Toto restaurant ,Dubai,UAE",
    location: "Dubai, UAE",
    client: "Toto restaurant ",
    completionDate: "January 2024",
    category: "Commercial",
    
    description: "Exclusive villas designed for modern living, offering privacy and beautiful landscapes.",
    image: toto, // This can be a single main image if you need
    im: [toto, toto1, toto2, toto3, toto4, toto5] // Store multiple images in an array
  },{
    id: 18,
    name: "Villa D24 ,Palm Jumairah",
    location: "Dubai, UAE",
    client: "Palm villa",
    completionDate: "September 2024",
    category: "Villas",
    
    description: "In this villa project, we provided top-tier flooring and wall cladding services. Our team used premium marble and stone to create elegant, durable floors, and applied precise wall cladding techniques for a refined, textured finish. The result is a luxurious, cohesive space that combines beauty with modern design.",
    image: plmcvr,
    im: [plm10, plm2, plm3, plm4, plm5, plm6,plm9,plm12,plm11,plm13] // Store multiple images in an array
  },{
    id: 19,
    name: "Villa D92 ,Palm Jumairah",
    location: "Dubai, UAE",
    client: "Palm villa",
    completionDate: "September 2023",
    category: "Villas",
    
    description: "In this villa project, we provided top-tier flooring and wall cladding services. Our team used premium marble and stone to create elegant, durable floors, and applied precise wall cladding techniques for a refined, textured finish. The result is a luxurious, cohesive space that combines beauty with modern design.",
    image: villa,
    im: [plmd921, plmd922, plmd923, plmd924, plmd925, plmd926] // Store multiple images in an array
  },{
    id: 20,
    name: "Manish Malhotra",
    location: "Dubai, UAE",
    client: "Manish Malhotra",
    completionDate: "September 2023",
    category: "Commercial",
    
    description: "In this villa project, we provided top-tier flooring and wall cladding services. Our team used premium marble and stone to create elegant, durable floors, and applied precise wall cladding techniques for a refined, textured finish. The result is a luxurious, cohesive space that combines beauty with modern design.",
    image: manish1,
    im: [manish,manish1,manish2,manish3] // Store multiple images in an array
  },
  {
    id: 21,
    name: "Imtiaz Beach Walk,Palm Deira,Duabi",
    location: "Dubai, UAE",
    client: "A&T GROUP INTERIORS LLC",
    completionDate: "July 2025",
    category: "Hotel & Residential",
    
    description: "The scope of work involved the supply and installation of natural stone finishes for both vertical and horizontal surfaces at the prestigious Imtiaz Beach Walk Lounge.",
    image: beachwalk,
    im: [beachwalk1,beachwalk2,beachwalk3,beachwalk4,beachwalk6,beachwalk7,beachwalk8,beachwalk9] // Store multiple images in an array
  },
  
];
